import { render, staticRenderFns } from "./StockyMigrationWizard.vue?vue&type=template&id=3b7d50cf&scoped=true"
import script from "./StockyMigrationWizard.vue?vue&type=script&lang=ts"
export * from "./StockyMigrationWizard.vue?vue&type=script&lang=ts"
import style0 from "./StockyMigrationWizard.vue?vue&type=style&index=0&id=3b7d50cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7d50cf",
  null
  
)

export default component.exports